var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.758333 16H12.2417C12.6581 16 13 15.6464 13 15.2107V7.64286C13 7.20714 12.6615 6.85714 12.2417 6.85714H11.5104V5.75357C11.5104 4.27143 10.962 2.625 10.0682 1.63214C9.17786 0.639286 7.90156 0 6.50339 0C6.5 0 6.5 0 6.5 0H6.49661C5.09844 0 3.82214 0.639286 2.93177 1.62857C2.03802 2.62143 1.48958 4.26786 1.48958 5.75V6.85714H0.846354H0.758333C0.338542 6.85714 0 7.21071 0 7.64286V15.2107C0 15.6464 0.338542 16 0.758333 16ZM3.28385 5.75357C3.28385 4.77857 3.61901 3.57143 4.23516 2.88571V2.875C4.83099 2.21071 5.65365 1.82143 6.49661 1.82143H6.5H6.50339C7.34635 1.82143 8.16901 2.21071 8.76484 2.875V2.88214L8.76146 2.88571C9.38099 3.57143 9.71276 4.77857 9.71276 5.75357V6.85714H9.12031H3.87292H3.28385V5.75357Z",
    fill: "#D7EED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLock);
export default __webpack_public_path__ + "static/media/modal-lock.ec9ecf47f041cea20851cfcfe104e4fa.svg";
export { ForwardRef as ReactComponent };